<template>
  <div class="card sub-card" v-if="lastSubscription">
    <a-card style="margin-bottom: 16px">
      <div class="tags-wrapper">
        <a-tag :class="{'red-tag': !lastSubscription.is_active, 'ant-tag-green': lastSubscription.is_active}">
          {{ lastSubscription.is_active ? 'Активна' : 'Истекла' }}
        </a-tag>
        <a-tag>
          <template #icon>
            <ClockCircleOutlined />
          </template>
          {{ (lastSubscription.is_active ? 'До ' : '') + lastSubscription.expired_at }}
        </a-tag>
      </div>
      <h2 class="sub-title">
        Подписка: &laquo;{{ lastSubscription.title }}&raquo;
      </h2>
      <div v-if="lastSubscription.description" class="grey-text sub-desc">
        {{ lastSubscription.description}}
      </div>
      <div class="sub-actions">
        <a-button class="primary-button">
          Продлить
        </a-button>
        <div class="group-action-wrapper">
          <a-dropdown :trigger="['click']" placement="bottomLeft">
            <a-button type="text" @click.prevent>
              <MoreOutlined class="more-button" />
            </a-button>

            <template #overlay>
              <a-menu>
                <a-menu-item key="details">Подробное описание</a-menu-item>
                <a-menu-item key="options" @click="() => showOptions()">Смотреть тарифы</a-menu-item>
                <a-menu-item v-if="lastSubscription.is_active" @click="() => deactivateSubscription(lastSubscription.id)" key="discontinue">Отключить</a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
      </div>
    </a-card>

    <a-alert
        v-if="lastSubscription?.unfinishedPassings?.length && lastSubscription.is_active"
        type="warning"
        show-icon
        style="border: unset; margin-bottom: 16px"
        closable
    >
      <template #message>
        У {{ lastSubscription?.unfinishedPassings.length + ' ' + getWordFormBasedOnTheCount(lastSubscription?.unfinishedPassings.length, 'сотрудника', 'сотрудников', 'сотрудников')  }}
        не начата оценка. Напомните сотрудникам пройти тестирования до {{ lastSubscription.expired_at }}, чтобы доступы не сгорели. <span class="remind-button" @click="remindAboutTest">Напомнить</span>
      </template>
    </a-alert>

    <div class="sub-quota-list">
      <a-card class="product-card">
        <h3>Доступы к оценке (ТЭИ)</h3>
        <p class="grey-text">
          Тесты эмоционального интеллекта
        </p>
        <div v-if="currentQuotas.tests.length" class="quota-details">
          <div v-for="test in currentQuotas.tests" :key="test.name">
            <div class="product-info">
              <p class="product-title">
                {{ test.name }}
              </p>
              <div class="product-quantity" v-if="lastSubscription.is_active">
                <span class="issued-quotas">{{ test.issued }}</span> / {{ test.total }}
              </div>
              <div v-else :class="{'grey-text': !lastSubscription.is_active}" class="locker">
                <LockFilled />
              </div>
            </div>
            <a-progress v-if="lastSubscription.is_active" :stroke-color="'#21AC0C'" :percent="test.issued / test.total * 100" :showInfo="false" />
            <a-progress v-else :showInfo="false" />
          </div>
        </div>
      </a-card>


      <a-card class="product-card">
        <h3>Доступы к тренажерам</h3>
        <p class="grey-text">
          Развитие навыков эмоционального интеллекта
        </p>
        <div v-if="currentQuotas.tests.length" class="quota-details">
          <div v-for="test in currentQuotas.courses" :key="test.name">
            <div class="product-info">
              <p class="product-title">
                {{ test.name }}
              </p>
              <div class="product-quantity" v-if="lastSubscription.is_active">
                <span class="issued-quotas">{{ test.issued }}</span> / {{ test.total }}
              </div>
              <div v-else :class="{'grey-text': !lastSubscription.is_active}" class="locker">
                <LockFilled />
              </div>
            </div>
            <a-progress v-if="lastSubscription.is_active" :stroke-color="'#21AC0C'" :percent="test.issued / test.total * 100" :showInfo="false" />
            <a-progress v-else :showInfo="false" />
          </div>
        </div>
      </a-card>

      <a-card class="product-card benchmarking">
        <h3>Функционал</h3>
        <p class="grey-text">
          Безлимитные возможности вашей подписки
        </p>
        <div class="quota-details">
          <div>
            <div class="product-info">
              <p class="product-title title-green">
                Бенчмаркинг
              </p>
              <div class="product-quantity" v-if="lastSubscription.is_active && currentQuotas.instruments.benchmark">
                <CheckCircleFilled style="color: var(--main-green)" />
              </div>
              <div v-else class="grey-text locker">
                <LockFilled />
              </div>
            </div>

            <div class="product-info">
              <p class="product-title title-green">
                База знаний по ЭИ (+ AI помощник)
              </p>
              <div class="product-quantity" v-if="lastSubscription.is_active && currentQuotas.instruments.knowledge">
                <CheckCircleFilled style="color: var(--main-green)" />
              </div>
              <div v-else class="grey-text locker">
                <LockFilled />
              </div>
            </div>

            <div class="product-info">
              <p class="product-title title-green">
                Мини-практикум «Клиентский сервис»
              </p>
              <div class="product-quantity" v-if="lastSubscription.is_active && currentQuotas.instruments.practicum">
                <CheckCircleFilled style="color: var(--main-green)" />
              </div>
              <div v-else class="grey-text locker">
                <LockFilled />
              </div>
            </div>

            <div class="product-info">
              <p class="product-title title-green">
                Ежедневные инструменты: Дневник, Навигатор эмоций
              </p>
              <div class="product-quantity" v-if="lastSubscription.is_active && currentQuotas.instruments.instruments.length">
                <CheckCircleFilled style="color: var(--main-green)" />
              </div>
              <div v-else class="grey-text locker">
                <LockFilled />
              </div>
            </div>
          </div>
        </div>
      </a-card>

      <a-card class="product-card">
        <h3>Экспертная поддержка</h3>
        <p class="grey-text">
          Консультации и стратегические продукты
        </p>
        <div class="quota-details">
          <div>
            <div>
              <div class="product-info">
                <p class="product-title title-green">
                  Сессии с HR-экспертом
                </p>
                <div class="product-quantity" v-if="lastSubscription.is_active && currentQuotas.specialProfiles.sessions.length">
                  <span class="issued-quotas">{{ currentQuotas.specialProfiles.sessions.issued }}</span> / {{ currentQuotas.specialProfiles.sessions.total }}
                </div>
                <div v-else class="grey-text locker">
                  <LockFilled />
                </div>
              </div>
              <a-progress v-if="lastSubscription.is_active && currentQuotas.specialProfiles.sessions.length" :stroke-color="'#21AC0C'" :percent="currentQuotas.specialProfiles.sessions.issued / currentQuotas.specialProfiles.sessions.total * 100" :showInfo="false" />
              <a-progress v-else :showInfo="false" />
            </div>

            <div>
              <div class="product-info">
                <p class="product-title title-green">
                  Эталонный профиль
                </p>
                <div class="product-quantity" v-if="lastSubscription.is_active && currentQuotas.specialProfiles.reference_profile">
                  <span class="issued-quotas">{{ currentQuotas.specialProfiles.reference_profile.issued }}</span> / {{ currentQuotas.specialProfiles.reference_profile.total }}
                </div>
                <div v-else class="grey-text locker">
                  <LockFilled />
                </div>
              </div>
              <a-progress v-if="lastSubscription.is_active && currentQuotas.specialProfiles.reference_profile" :stroke-color="'#21AC0C'" :percent="currentQuotas.specialProfiles.reference_profile.issued / currentQuotas.specialProfiles.reference_profile.total * 100" :showInfo="false" />
              <a-progress v-else :showInfo="false" />
            </div>

            <div>
              <div class="product-info">
                <p class="product-title title-green">
                  ЭИ-ландшафт команды
                </p>
                <div class="product-quantity" v-if="lastSubscription.is_active && currentQuotas.specialProfiles.landscape.length">
                  <span class="issued-quotas">{{ currentQuotas.specialProfiles.landscape.issued }}</span> / {{ currentQuotas.specialProfiles.landscape.total }}
                </div>
                <div v-else class="grey-text locker">
                  <LockFilled />
                </div>
              </div>
              <a-progress v-if="lastSubscription.is_active && currentQuotas.specialProfiles.landscape.length" :stroke-color="'#21AC0C'" :percent="currentQuotas.specialProfiles.landscape.issued / currentQuotas.specialProfiles.landscape.total * 100" :showInfo="false" />
              <a-progress v-else :showInfo="false" />
            </div>
          </div>
        </div>
      </a-card>
    </div>

  </div>
</template>

<script>
import {computed, reactive} from "@vue/reactivity";
  import {useStore} from "vuex";
import {CheckCircleFilled, ClockCircleOutlined, LockFilled, MoreOutlined} from "@ant-design/icons-vue";
  import {getWordFormBasedOnTheCount} from "../Report/utils";
  import {message} from "ant-design-vue";
import {onBeforeMount, watch} from "@vue/runtime-core";

  export default {
    methods: {getWordFormBasedOnTheCount},
    components: {CheckCircleFilled, LockFilled, MoreOutlined, ClockCircleOutlined},
    emits: ['showOptions'],
    setup(props, context) {
      const store = useStore();
      const currentSubscriptionSummary = computed(() => store.state.subscription.subscriptionSummary);

      const lastSubscription = computed(() => currentSubscriptionSummary.value[0] ?? null)

      const showOptions = () => {
        context.emit('showOptions');
      }

      const deactivateSubscription = (subId) => {
        store.dispatch("subscription/expireSubscription", {subscriptionId: subId, type: 'company'});
      }

      const remindAboutTest = async () => {
        await lastSubscription.value.unfinishedPassings.map(async (el) => {
          await store.dispatch("test/remindTest", el.code);
        });

        message.success('Напоминания отправлены');
      };

      const currentQuotas = reactive({
        tests: [],
        courses: [],
        specialProfiles: {
          reference_profile: false,
          sessions: [],
          landscape: [],
        },
        instruments: {
          benchmark: true,
          knowledge: false,
          practicum: false,
          instruments: [],
        },
      });

      watch(() => lastSubscription.value, () => {
        if (lastSubscription.value) {
          lastSubscription.value?.products.map((el) => {
            if (el.type === 'test') {
              currentQuotas.tests.push({
                name: el.title,
                issued: el.issuedCount,
                total: el.totalCount,
              })
            } else if (el.type === 'course') {
              currentQuotas.courses.push({
                name: el.title,
                issued: el.issuedCount,
                total: el.totalCount,
              });
            } else if (el.type === 'instrument') {
              currentQuotas.instruments.instruments.push(el.title);
            } else if (el.type === 'reference_profile') {
              currentQuotas.specialProfiles.reference_profile = {
                name: el.name,
                issued: el.issuedCount,
                total: el.totalCount,
              };
            }
          });
        }
      }, {immediate: true})

      return {
        currentSubscriptionSummary,
        showOptions,
        lastSubscription,
        deactivateSubscription,
        remindAboutTest,
        currentQuotas
      }
    }
  }
</script>

<style scoped lang="scss">
.tags-wrapper {
  display: flex;
  column-gap: 8px;
  margin-bottom: 12px;
}

:deep(.ant-tag) {
  display: flex;
  width: fit-content;
  margin-inline-end: 0;
}

.sub-title {
  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
  margin-bottom: 8px;
}

.sub-card .grey-text {
  font-size: 14px;
  margin-bottom: 16px;
}

.sub-card .product-info {
  display: flex;
  justify-content: space-between;
  column-gap: 10px;

  .grey-text {
    margin-bottom: 8px;
  }

  .grey-text.locker {
    margin-bottom: 0;
  }

  p {
    margin-bottom: 0;
  }

  .title-green {
    color: var(--main-green);
  }
}

:deep(.group-action-wrapper .ant-btn-text:not(:disabled):hover) {
  background-color: unset;
}

.group-action-wrapper {
  border: 1px solid #d9d9d9;

  button {
    color: var(--main-font) !important;
  }
}

.group-action-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: #FFFFFF;
  border-radius: 25%;
  cursor: pointer;
}

.group-action-wrapper:hover {
  border-color: var(--hover-green);
}

.group-action-wrapper:hover button {
  color: var(--hover-green) !important;
}

.sub-actions {
  display: flex;
  column-gap: 8px;

  @media (max-width: $mobile-breakpoint) {
    .primary-button {
      width: 95%;
    }
  }
}

.remind-button {
  cursor: pointer;
  text-decoration: underline;
}

.sub-quota-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 16px;
  column-gap: 16px;

  @media (max-width: $mobile-breakpoint) {
    grid-template-columns: 1fr;
  }
}

.sub-quota-list h3 {
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
}

.quota-details {
  margin-top: auto;

  .product-info.grey-text {
    margin-bottom: 0;
  }
}

.benchmarking .quota-details {
  margin-top: 0;

  .title-green {
    margin-bottom: 16px;
  }
}

.product-card {
  display: flex;
  flex-direction: column;
}

.issued-quotas {
  font-weight: 600;
}

:deep(.ant-card-body) {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>